import { render, staticRenderFns } from "./TripClubbing.vue?vue&type=template&id=036a028e&scoped=true&"
import script from "./TripClubbing.vue?vue&type=script&lang=js&"
export * from "./TripClubbing.vue?vue&type=script&lang=js&"
import style0 from "./TripClubbing.vue?vue&type=style&index=0&id=036a028e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a028e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCheckbox})
